import { call, put, select, takeLatest } from 'redux-saga/effects';

import { getTripsCsvRequest, getTripsCsvSuccess } from '../../slices/trip';
import axios from '../axiosConfig';

const queryString = require('query-string');

function* tripsCSVRequestWorker() {
  try {
    const { tripsSearch } = yield select((store) => store.trip);
    const config = {
      method: 'get',
      headers: {
        'Content-Type': 'text/csv',
      },
      url: `trips/getTripsCSV?${queryString.stringify(
        {
          pageSize: -1,
          filterTravelAgencyIds:
            tripsSearch && tripsSearch.searchObj && tripsSearch.searchObj.filterTravelAgencyIds,
        },
        { skipNull: true },
      )}`,
    };
    const response = yield call(axios, config);
    if (response.data) {
      yield put(getTripsCsvSuccess({ data: response.data }));
    } else throw new Error();
  } catch (error) {
    yield put(getTripsCsvSuccess({}));
  }
}

function* tripsCSVRequestWatcher() {
  yield takeLatest(getTripsCsvRequest.toString(), tripsCSVRequestWorker);
}

export default tripsCSVRequestWatcher;
